<div class="ui-g loyalty-cluster" *ngIf="show.datatable">
  <div class="ui-g-12">

    <app-kontable #table title="{{ 'cluster.clusterTableTitle' | translate }}" [columns]="[
                    'id',
                    'description',
                    { field: 'cluster_type_code', title: 'cluster.type', filterType: selectFilter, filterOptions: {values: listClusterType} },
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter},
                    { field: 'code', title: 'cluster.code'}
                  ]" [titles]="['common.id', 'common.description']" [paginationType]="serverPagination"
      [showInfoButton]="false" [showRecoverButton]="true" [showGlobalFilter]="false" [showDetailsButton]="false"
      [showAddButton]="true" [service]="clusterService" [(fireNewDataAvailable)]="newDataAvailable"
      [servicePermissions]="clusterPermission" (onAdd)="addNew($event)" (onEdit)="edit($event)"
      (onRecover)="recover($event)" (onRemove)="remove($event)">
      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
        <ng-container [ngSwitch]="row.flg_state">
          <span *ngSwitchCase="'1'">
         {{ 'common.coupon_deleted' | translate }}
          </span>
          <span *ngSwitchDefault>
          {{ 'common.coupon_valid' | translate }}
          </span>
        </ng-container>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
        <p-dropdown [options]="listStates" [style]="{'width':'100%'}"
          (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"
          [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>


    </app-kontable>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster/loyalty-cluster.component.html